var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('largest-three-month-move',{attrs:{"data":_vm.data}})],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('largest-six-month-move',{attrs:{"data":_vm.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }